import cx from "classnames";
import React from "react";
import { FormErrors } from "redux-form";

import { faqAntiScamUrl } from "@/mk2/apps/faq/urls";
import { Btn, BtnType } from "@/mk2/components/Btn";
import { ExpandableClamp } from "@/mk2/components/ExpandableClamp";
import { Form } from "@/mk2/components/Form";
import { Link } from "@/mk2/components/Link";
import { SubmitButton } from "@/mk2/components/forms/SubmitButton";
import { TextareaField } from "@/mk2/components/forms/TextareaField";
import { UploadedPhoto } from "@/mk2/containers/PhotosUpload/PhotosUpload";
import { ComposeToolbar, FIXED } from "@/mk2/containers/Toolbar/Toolbar";
import { MKReduxFormInjectedProps, mkReduxForm } from "@/mk2/decorators/mkReduxForm";
import {
    ABOUT_ME_MORE_ABOUT_ME,
    BAZAAR_MESSAGES_ALERT_LINE1,
    BAZAAR_MESSAGES_ALERT_LINE2,
    BAZAAR_MESSAGES_ALERT_LINE3,
    BAZAAR_MESSAGES_ALERT_LINE4,
    BAZAAR_MESSAGES_ALERT_LINE5,
    BAZAAR_MESSAGES_ALERT_TITLE,
    BZ2_SUBMIT_MESSAGE,
    CANCEL,
    FORMS_DEFAULT_REQUIRED_FIELD_ERROR,
    SHOW_FULL_MESSAGE,
} from "@/mk/autogenerated/translations/MessageForm.e9d44725ece1d515b7212ebf10e629bb";

import styles from "./MessageForm.mscss";

export interface MessageFormData {
    message: string;
    photos: UploadedPhoto[];
}

const emojisConfig = {
    fields: ["message"],
    defaultField: "message",
};

const photosConfig = {
    photoType: "bzmessage",
    multiple: true,
    previewPhotoSize: "s150x150",
    showPhotoCode: false,
};

interface OwnProps {
    className?: string;
    initialValues: MessageFormData;
    form: string;

    onSave(values: MessageFormData);
    onCancel(event: React.MouseEvent<HTMLAnchorElement>);
}

type Props = OwnProps;

class MessageForm extends React.Component<
    Props & MKReduxFormInjectedProps<MessageFormData, Props>
> {
    public render() {
        const { className, handleSubmit, form, onCancel } = this.props;

        return (
            <Form className={cx(styles.MessageForm, className)} onSubmit={handleSubmit}>
                {BAZAAR_MESSAGES_ALERT_TITLE && BAZAAR_MESSAGES_ALERT_TITLE.length > 1 && (
                    <div className={styles.MessageForm__alert}>
                        <ExpandableClamp expandLabel={SHOW_FULL_MESSAGE} clamp={2}>
                            <div>
                                <p className={styles.MessageForm__alert__title}>
                                    <b>{BAZAAR_MESSAGES_ALERT_TITLE}</b>
                                </p>
                                <p>{BAZAAR_MESSAGES_ALERT_LINE1}</p>
                                <p>{BAZAAR_MESSAGES_ALERT_LINE2}</p>
                                <p>{BAZAAR_MESSAGES_ALERT_LINE3}</p>
                                <p>
                                    <b>
                                        <Link to={faqAntiScamUrl}>
                                            {BAZAAR_MESSAGES_ALERT_LINE4}
                                        </Link>
                                    </b>
                                </p>
                                <p>{BAZAAR_MESSAGES_ALERT_LINE5}</p>
                            </div>
                        </ExpandableClamp>
                    </div>
                )}
                <div className={styles.MessageForm__message}>
                    <TextareaField
                        name="message"
                        autoFocus
                        rows={3}
                        maxRows={5}
                        maxLength={3000}
                        bottomBorder={false}
                        isCompact
                    />
                </div>

                <ComposeToolbar
                    className={styles.MessageForm__toolbar}
                    formName={form}
                    emojis={emojisConfig}
                    photos={photosConfig}
                    stickers={false}
                    isFixed={FIXED.NEVER}
                    isInBlogs
                    rightAction={
                        <div className={styles.MessageForm__actionButtons}>
                            <Btn
                                className={styles.MessageForm__cancel}
                                type={BtnType.Link}
                                label={CANCEL}
                                onClick={onCancel}
                            />
                            <SubmitButton
                                className={styles.MessageForm__submit}
                                label={BZ2_SUBMIT_MESSAGE}
                                formName={form}
                                btnType={BtnType.Blue}
                            />
                        </div>
                    }
                />
            </Form>
        );
    }
}

function validate(values: MessageFormData): FormErrors<MessageFormData> {
    const errors: FormErrors<MessageFormData> = {};
    if (!values.message) {
        errors.message = FORMS_DEFAULT_REQUIRED_FIELD_ERROR;
    }

    return errors;
}

export default mkReduxForm<MessageFormData, Props>({
    photosConfig,
    onValidate: validate,
    onSave: (values, props) => props.onSave(values),
})(MessageForm);
